/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  DashboardLayoutDTO,
  UserDashboardLayoutGetMyLayoutParams,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useUserDashboardLayoutGetMyLayoutHook = () => {
  const userDashboardLayoutGetMyLayout =
    useCustomInstance<DashboardLayoutDTO>();

  return useCallback(
    (params?: UserDashboardLayoutGetMyLayoutParams, signal?: AbortSignal) => {
      return userDashboardLayoutGetMyLayout({
        url: `/api/UserDashboardLayout/GetMyLayout`,
        method: 'GET',
        params,
        signal,
      });
    },
    [userDashboardLayoutGetMyLayout]
  );
};

export const getUserDashboardLayoutGetMyLayoutQueryKey = (
  params?: UserDashboardLayoutGetMyLayoutParams
) => {
  return [
    `/api/UserDashboardLayout/GetMyLayout`,
    ...(params ? [params] : []),
  ] as const;
};

export const useUserDashboardLayoutGetMyLayoutQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useUserDashboardLayoutGetMyLayoutHook>>
  >,
  TError = unknown,
>(
  params?: UserDashboardLayoutGetMyLayoutParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useUserDashboardLayoutGetMyLayoutHook>>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getUserDashboardLayoutGetMyLayoutQueryKey(params);

  const userDashboardLayoutGetMyLayout =
    useUserDashboardLayoutGetMyLayoutHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useUserDashboardLayoutGetMyLayoutHook>>
    >
  > = ({ signal }) => userDashboardLayoutGetMyLayout(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useUserDashboardLayoutGetMyLayoutHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserDashboardLayoutGetMyLayoutQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUserDashboardLayoutGetMyLayoutHook>>>
>;
export type UserDashboardLayoutGetMyLayoutQueryError = unknown;

export const useUserDashboardLayoutGetMyLayout = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useUserDashboardLayoutGetMyLayoutHook>>
  >,
  TError = unknown,
>(
  params?: UserDashboardLayoutGetMyLayoutParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useUserDashboardLayoutGetMyLayoutHook>>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useUserDashboardLayoutGetMyLayoutQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useUserDashboardLayoutSaveMyLayoutHook = () => {
  const userDashboardLayoutSaveMyLayout = useCustomInstance<Blob>();

  return useCallback(
    (dashboardLayoutDTO: DashboardLayoutDTO) => {
      return userDashboardLayoutSaveMyLayout({
        url: `/api/UserDashboardLayout/SaveMyLayout`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: dashboardLayoutDTO,
        responseType: 'blob',
      });
    },
    [userDashboardLayoutSaveMyLayout]
  );
};

export const useUserDashboardLayoutSaveMyLayoutMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useUserDashboardLayoutSaveMyLayoutHook>>
    >,
    TError,
    { data: DashboardLayoutDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useUserDashboardLayoutSaveMyLayoutHook>>
  >,
  TError,
  { data: DashboardLayoutDTO },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const userDashboardLayoutSaveMyLayout =
    useUserDashboardLayoutSaveMyLayoutHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useUserDashboardLayoutSaveMyLayoutHook>>
    >,
    { data: DashboardLayoutDTO }
  > = (props) => {
    const { data } = props ?? {};

    return userDashboardLayoutSaveMyLayout(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserDashboardLayoutSaveMyLayoutMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUserDashboardLayoutSaveMyLayoutHook>>>
>;
export type UserDashboardLayoutSaveMyLayoutMutationBody = DashboardLayoutDTO;
export type UserDashboardLayoutSaveMyLayoutMutationError = unknown;

export const useUserDashboardLayoutSaveMyLayout = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useUserDashboardLayoutSaveMyLayoutHook>>
    >,
    TError,
    { data: DashboardLayoutDTO },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useUserDashboardLayoutSaveMyLayoutHook>>
  >,
  TError,
  { data: DashboardLayoutDTO },
  TContext
> => {
  const mutationOptions =
    useUserDashboardLayoutSaveMyLayoutMutationOptions(options);

  return useMutation(mutationOptions);
};
